import { Location } from '@/graphql/types';

/**
 * Calculate the distance between two geographic coordinates using the Haversine formula
 * @param point1 First location (lat, lng)
 * @param point2 Second location (lat, lng)
 * @param unit Unit of measurement: 'mi' for miles, 'km' for kilometers
 * @returns Distance in the specified unit
 */
export const calculateDistance = (
  point1: Location,
  point2: Location,
  unit: 'mi' | 'km' = 'mi'
): number => {
  const R = unit === 'mi' ? 3959 : 6371; // Earth's radius in miles or kilometers
  const dLat = ((point2.lat - point1.lat) * Math.PI) / 180;
  const dLon = ((point2.lng - point1.lng) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((point1.lat * Math.PI) / 180) *
      Math.cos((point2.lat * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return Math.round(distance * 10) / 10; // Round to 1 decimal place
};


